import { memo, FC, useMemo } from 'react'

import { formatNumberWithPunctuation } from 'utils/transforms/number'
import MetadataText from './components/MetadataText'

type PossibleFields = {
  [key: string]: JSX.Element
}

type Props = {
  type: string | 'TEXT' | 'STRING' | 'DATE' | 'DATETIME' | 'NUMBER' | 'BOOLEAN'
  label?: string
  value?: string
}

const DynamicTextByType: FC<Props> = ({ type, label, value }) => {
  const Component = useMemo(() => {
    const possibleFields: PossibleFields = {
      STRING: <MetadataText type={type} label={label} value={value} />,
      TEXT: <MetadataText type={type} label={label} value={value} />,
      NUMBER: <MetadataText type={type} label={label} value={value} formatValue={(value) => formatNumberWithPunctuation(Number(value))} />,
      BOOLEAN: <MetadataText type={type} label={label} value={value} />,
      DATE: <MetadataText type={type} label={label} value={value} />,
      DATETIME: <MetadataText type={type} label={label} value={value} />,
    }

    return possibleFields[type]
  }, [])

  return Component
}

export default memo(DynamicTextByType)
